module.exports = __webpack_public_path__ + "img/excel-green-used.f6db1eec.svg";